export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleString('ru', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timezone: 'UTC',
    hour: 'numeric',
    minute: 'numeric',
  })
}

export const userLang = () => {
  const lang = localStorage.getItem('i18nextLng') || navigator.language || navigator.userLanguage
  return ['ru', 'en'].includes(lang) ? lang : 'ru'
}

export const formatDate2 = (dateString) => {
  return new Date(dateString).toISOString().split('T')[0]
}

export const scroll = (selector) => {
  const section = document.querySelector(`${selector}`)
  return section
    ? section.scrollIntoView({ behavior: 'smooth', block: 'start' })
    : null
}

export const checkWindow = (maxWidthPixel) =>
  typeof window !== 'undefined' &&
  window.matchMedia(`(max-width: ${maxWidthPixel}px)`).matches

export const isMobile = checkWindow(1024)

export const isPhone = checkWindow(768)

export const rebuildData = (values) => {
  console.log(values,'REBUILD')
  let formData = new FormData()
  if (values.name)
    formData.append(`name`, values.name)
  if (values.surname)
    formData.append(`surname`, values.surname)
  if (values.country_id)
    formData.append(`country_id`, values.country_id?.value)
  if (values.citizenship_id)
    formData.append(`citizenship_id`, values.citizenship_id?.value)
  if (values.patronymic) formData.append(`patronymic`, values.patronymic)
  if (values.birthday) formData.append(`birthday`,values.birthday)
  if (values.sex)
    formData.append(`sex`, values.sex.value)
  if (values.phone)
    formData.append(`phone`, values.phone)
  if (values.email) formData.append(`email`, values.email)
  if (values.password)
    formData.append(`password`, values.password)
  if (values.job?.organisation_name)
    formData.append(`job[organisation_name]`, values.job?.organisation_name)
  if (values.job?.position)
    formData.append(`job[position]`, values.job?.position)
  if (values.passport?.number) formData.append(`passport[number]`, values.passport?.number)
  if (values.passport?.create_date) formData.append(`passport[create_date]`, values.passport?.create_date)
  if (values.passport?.expire_date)
    formData.append(`passport[expire_date]`, values.passport?.expire_date)
  if (values.flight_schedules?.input?.name)
    formData.append(`flight_schedules[input][name]`, values.flight_schedules?.input?.name)
  if (values.flight_schedules?.input?.date)
    formData.append(`flight_schedules[input][date]`, values.flight_schedules?.input?.date)
  if (values.flight_schedules?.input?.time)
    formData.append(`flight_schedules[input][time]`, values.flight_schedules?.input?.time)
  if (values.flight_schedules?.exit?.name)
    formData.append(`flight_schedules[exit][name]`, values.flight_schedules?.exit?.name)
  if (values.flight_schedules?.exit?.date)
    formData.append(`flight_schedules[exit][date]`, values.flight_schedules?.exit?.date)
  if (values.flight_schedules?.exit?.time)
    formData.append(`flight_schedules[exit][time]`, values.flight_schedules?.exit?.time)
  if (values.food)
    formData.append(
      `food`,
      values.food,
    )
  return formData
}


export const defineCN = (lang) => {
    if (lang === 'ru-RU' || lang === 'ru') {
        return '_lang_ru'
    }

    // if (lang === 'en-EN' || lang === 'en') {
    //     return '_lang_en'
    // }

    // if (lang === 'fr-FR' || lang === 'fr') {
    //     return '_lang_fr'
    // }

    return '_lang_en'
}
